module.exports = __webpack_public_path__ + "static/media/roundprofile.a23f4e6a.svg";